import { PaymentType } from './selectPaymentType';
import { SubmitCaseContext } from './types';
import { needsFileUpload } from '../../util/case';

export const isCaseInfoValid = (context: SubmitCaseContext) => true;
export const areSitesValid = (context: SubmitCaseContext) =>
  (context.caseInfo?.sites.length || 0) > 0;
export const canSetupIntent = (context: SubmitCaseContext) =>
  !!(context.userId && context.email && context.name);
export const canAddPaymentMethod = (context: SubmitCaseContext) =>
  !!(context.clientSecret && context.stripe && context.elements);
export const hasPaymentMethod = (context: SubmitCaseContext) =>
  !!context.paymentMethods && context.paymentMethods.length > 0;
export const hasConfirmedSetupIntent = ({
  setupIntent,
  selectedPaymentMethod,
}: SubmitCaseContext) =>
  !!setupIntent &&
  setupIntent.next_action === null &&
  setupIntent.status === 'succeeded' &&
  setupIntent.payment_method === selectedPaymentMethod;
export const hasNoSetupIntent = ({ setupIntent }: SubmitCaseContext) =>
  !setupIntent;
export const isAttachedToHospital = (context: SubmitCaseContext) => {
  return Boolean(context.parentAccount);
};
export const isInvoicing = (context: SubmitCaseContext) => {
  return context.paymentType === PaymentType.INVOICE;
};
export const isInvoicingParentAccount = (context: SubmitCaseContext) => {
  return context.selectedInvoiceAccountUid === context.parentAccount?.uid;
};
export const hasLoadedInvoices = (context: SubmitCaseContext) => {
  return context.hasLoadedInvoices;
};
export const isInvoicingDisabled = (context: SubmitCaseContext) => {
  return context.invoicingDisabled;
};
export const hasLoadedPriorityInfo = (context: SubmitCaseContext) => {
  return context.hasLoadedPriorityInfo;
};
export const hasDraft = (context: SubmitCaseContext, event: any) => {
  return event.data !== null && event.data !== undefined;
};

export const canSkipToEnterInfo = (context: SubmitCaseContext) =>
  !!context.caseType;

export const canSkipToSelectPaymentType = (context: SubmitCaseContext) =>
  !!context.caseInfo && (context.caseInfo.sites?.length || 0) > 0;

export const canSkipToPayment = (context: SubmitCaseContext) =>
  !!context.caseInfo &&
  !!context.paymentType &&
  (context.caseInfo.sites?.length || 0) > 0;

export const canSkipToCheckout = (context: SubmitCaseContext) =>
  !!context.caseInfo &&
  !!context.paymentType &&
  (context.caseInfo.sites?.length || 0) > 0 &&
  (context.paymentType === PaymentType.INVOICE
    ? !!context.selectedInvoiceAccountUid
    : !!context.selectedPaymentMethod);

export const canAutoLoadToEnterInfo = (
  context: SubmitCaseContext,
  event: any
) => {
  const draft = event.data;
  if (!draft) return false;
  return !!draft.caseType;
};

export const canAutoLoadToSelectPaymentType = (
  context: SubmitCaseContext,
  event: any
) => {
  const draft = event.data;
  if (!draft) return false;
  return !!draft.caseInfo && (draft.caseInfo.sites?.length || 0) > 0;
};

export const canAutoLoadToPayment = (
  context: SubmitCaseContext,
  event: any
) => {
  const draft = event.data;
  if (!draft) return false;
  return (
    !!draft.caseInfo &&
    !!draft.paymentType &&
    (draft.caseInfo.sites?.length || 0) > 0
  );
};

export const canAutoLoadToCheckout = (
  context: SubmitCaseContext,
  event: any
) => {
  const draft = event.data;
  if (!draft) return false;
  return (
    !!draft.caseInfo &&
    !!draft.paymentType &&
    (draft.caseInfo.sites?.length || 0) > 0 &&
    (draft.paymentType === PaymentType.INVOICE
      ? !!draft.selectedInvoiceAccountUid
      : !!draft.selectedPaymentMethod)
  );
};

export const doesNotNeedUpload = (context: SubmitCaseContext, event?: any): boolean => {
  const caseInfo = event?.caseInfo || context.caseInfo;
  return !caseInfo?.sites || !needsFileUpload(caseInfo.sites);
};
